export default __webpack_public_path__ + "static/media/how-to-register-video.482ba50f.mp4";